import axios from 'axios'
import api from '@/store/api'

// Acțiuni dedicate ecranului „Mașină nouă în service" (IntrareNoua.vue).
// Spre deosebire de modulul `comenzi` (care lucrează pe state.comanda global),
// astea sunt pe bază de PAYLOAD și nu țin stare — formularul V2 e auto-conținut.
// Acțiunile sunt subțiri: fac axios și întorc `data`; NU prind erorile, ca
// apelantul (componenta) să poată decide UX-ul după status (404/422/500/network).
export const actions = {
  // Mod editare: încarcă intrarea existentă. Timeout explicit (15s) ca un server
  // care atârnă să nu lase pagina blocată la infinit. (DFF-A4)
  async in2_load_comanda (_ctx, id) {
    const { data } = await axios.get(`${api.comenzi}/get-comanda/${id}`, { timeout: 15000 })
    return data
  },

  // Creare intrare nouă.
  async in2_create_comanda (_ctx, payload) {
    const { data } = await axios.post(api.comanda_noua, payload)
    return data
  },

  // Actualizare intrare existentă.
  async in2_update_comanda (_ctx, { id, payload }) {
    const { data } = await axios.put(`${api.update_comanda}/${id}`, payload)
    return data
  },

  // Ștergere intrare. Self-contained: aruncă la eroare (nu înghite), ca
  // apelantul să decidă UX-ul (toast + redirect).
  async in2_delete_comanda (_ctx, id) {
    await axios.delete(`${api.comenzi}/delete-comanda/${id}`)
  },

  // Căutare firmă după CUI (populare câmpuri client).
  async in2_lookup_cui (_ctx, cui) {
    const { data } = await axios.get(`${api.lookup_cui}?cui=${encodeURIComponent(cui)}`)
    return data
  },

  // Documente: self-contained (pe bază de id), fără state.comanda global.
  // Upload: întoarce { document, url }; apelantul își actualizează lista local.
  async in2_upload_document (_ctx, { id, file }) {
    const formData = new FormData()
    formData.append('document', file)
    const { data } = await axios.post(`${api.comenzi}/${id}/document`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return data
  },

  // Ștergere document după stored_filename.
  async in2_delete_document (_ctx, { id, filename }) {
    await axios.delete(`${api.comenzi}/${id}/document`, {
      params: { filename }
    })
  },

  // Scanare talon: upload imagine, întoarce { car, client }.
  async in2_scan_talon (_ctx, file) {
    const formData = new FormData()
    formData.append('talon', file)
    const { data } = await axios.post(api.scan_talon, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return data
  }
}
